import { Flex, SystemStyleObject, Text } from '@chakra-ui/react';

import { getFullName } from '../../../gql/customerGql';
import { PhoneType } from '../../../gql/generated/graphql';

import { ConversationBox } from '../../../utils/messages';
import NotificationsAvatar from '../../NotificationBadge/NotificationAvatar';

type ContactBoxProps = {
  box: ConversationBox;
  handleClick: () => void;
  isActive: boolean;
  unreadCount?: number;
};
const activeTriangle: SystemStyleObject = {
  content: '""',
  position: 'absolute',
  bottom: '-12px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '0',
  height: '0',
  borderLeft: '12px solid transparent',
  borderRight: '12px solid transparent',
  borderTop: '12px solid',
  borderTopColor: 'gray.300',
  zIndex: 1,
};

const ContactBox = ({ box, handleClick, isActive, unreadCount = 0 }: ContactBoxProps) => (
  <Flex
    bgColor={isActive ? 'gray.300' : 'white'}
    w={{ base: '50%', md: '175px' }}
    flexShrink={0}
    minH="60px"
    cursor="pointer"
    onClick={handleClick}
    align="center"
    justify="center"
    px={4}
    gap={2}
    borderBottom={isActive ? '2px solid' : 'none'}
    borderColor={isActive ? 'gray.300' : 'transparent'}
    position="relative"
    _after={isActive ? activeTriangle : {}}
  >
    {getFullName(box.conversation).substring(0, 18)}
    {box.phoneType === PhoneType.Home && (
      <Text fontSize="xs" color="gray.500">
        {box.phoneType}
      </Text>
    )}
    <NotificationsAvatar count={unreadCount} />
  </Flex>
);

export default ContactBox;
